<template>
  <div>
    <v-dialog max-width="55.0rem" v-model="openBox" @keydown.esc="closeBox">
      <a style="width: 100%" v-if="hasActivator" slot="activator">{{
        activatorValue
      }}</a>
      <v-card class="card-padding" max-width="100%">
        <div class="heading-text">
          {{ header }}
        </div>
        <div class="body-text">
          {{ body }}
        </div>
        <div class="button-style">
          <span
            ><button @click="onClickOk" class="btn btn-save">
              {{ ok }}
            </button></span
          >
          <span class="button-spacing"
            ><button @click="onClickCancel" class="btn btn-cancel">
              Cancel
            </button></span
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "notification-box",
  props: {
    open: Boolean,
    title: String,
    message: String,
    hasActivator: Boolean,
    activatorValue: String,
    ok: {
      default: "Ok",
      type: String
    }
  },
  data: function() {
    return {
      openBox: this.open,
      header: this.title,
      body: this.message
    };
  },
  methods: {
    closeBox: function() {
      this.openBox = false;
    },

    onClickOk: function() {
      this.$emit("on-click-ok");
    },

    onClickCancel: function() {
      this.openBox = false;
      this.$emit("on-click-cancel");
    }
  }
};
</script>

<style scoped>
.card-padding {
  border: 0.1rem solid #cccccc !important;
  padding: 5rem 10%;
}
.heading-text {
  font-size: 3rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 3.5rem;
  color: #050405;
  text-align: left;
}
.body-text {
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 1.6rem;
  letter-spacing: 0;
  line-height: 3.3rem;
  color: #3d4249;
  text-align: left;
}
.button-style {
  display: flex;
  flex-direction: row;
  text-align: right;
}
.button-spacing {
  padding-left: 1rem;
}
</style>
